import { render, staticRenderFns } from "./propertyStatusForm.vue?vue&type=template&id=58b0cc18&%23default=true&"
import script from "./propertyStatusForm.vue?vue&type=script&lang=js&"
export * from "./propertyStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports